import React, {useState} from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
const style = {
    border: '1px dashed gray',
    backgroundColor: 'white',
    padding: '0.5rem 1rem',
    marginRight: '1.5rem',
    marginBottom: '1.5rem',
    cursor: 'move',
    float: 'left',
};
export const Box = (props) => {
    const [{ isDragging }, drag] = useDrag({
        item: { name: props.info.file_name, file_id: props.info.id, duration: props.info.duration, type: ItemTypes.BOX },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                props.onDropToTimeline({
                    id: item.file_id,
                    duration: props.info.duration,
                    file_name: item.name
                });
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const opacity = isDragging ? 0.4 : 1;
    return (
        <div style={{border: "2px solid #CFAA67", borderRadius: "2px", opacity }} ref={drag}>
            {props.info.media_type === "image" ? (
                <img src={props.info.url} style={{width: "100%", height: "100px"}} />
            ) : props.info.media_type === "video" ? (
                <video style={{width: "100%", height: "100px"}}>
                    <source src={props.info.url} type="video/mp4" />
                </video>
            ) : ""}
            <div className="text-center font-size-13 m-auto" style={{backgroundColor: "#FFF6CC"}}>
                {props.info.file_name}
            </div>
        </div>);
};
